import type { SvgIconProps } from "@mui/material";
import FinancialStatementIcon from "@entrilia/shared/icons/FinancialStatementIcon.tsx";

// The shared glyph has no padding, unlike the other report type icons.
const FinancialStatementReportIcon = (props: SvgIconProps) => (
  <FinancialStatementIcon viewBox="-5 -3 26 26" {...props} />
);

export default FinancialStatementReportIcon;
